import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ScrollRestoration, useLocation } from 'react-router';

import AutoScrollToTop from './components/AppLayout/AutoScrollToTop';
import Layout from './components/AppLayout/Layout';
import Authenticator from './components/SecureRoutes/Authenticator';
import CookieBanner from './pages/Cookies/CookieBanner';
import SomethingWentWrong from './pages/Error/SomethingWentWrong';
import { resetError } from './redux/status/actions';
import './tokens-override.css';
import './App.css';

interface RootState {
  status: {
    error: string | null;
  };
}

const AppLayout = (): React.JSX.Element => {
  const dispatch = useDispatch();
  const location = useLocation();
  const reduxError = useSelector((state: RootState) => state.status.error);

  useEffect(() => {
    if (reduxError) {
      dispatch(resetError());
    }
  }, [location, dispatch, reduxError]);

  if (reduxError === 'NETWORK_ERROR') {
    return <SomethingWentWrong />;
  }
  return (
    <>
      {/* We need ScrollToTop in addition to ScrollRestoration because the latter
      misbehaves in some cases. */}
      <AutoScrollToTop />
      <ScrollRestoration />
      <CookieBanner />
      <Authenticator>
        <Layout />
      </Authenticator>
    </>
  );
};

export default AppLayout;
